export const LANDING_PATH = '/';
export const PORTAL_PATH = '/portal';
export const DATASETS_PATH = `${PORTAL_PATH}/datasets`;
export const PROJECTS_PATH = `${PORTAL_PATH}/projects`;
export const PUBLIC_DATASETS_PATH = `${PORTAL_PATH}/public-datasets`;
export const PUBLIC_PROJECTS_PATH = `${PORTAL_PATH}/public-projects`;
export const HOME_PATH = PROJECTS_PATH;
export const PLUS_MEMBERSHIP = 'wow-plus-membership';
export const HEALTH_SHARING = 'health-sharing';
export const OFFICE_VISIT = 'office-visit';
export const VIRTUAL_URGENT_CARE = 'virtual-urgent-care';
export const MENTAL_HEALTH_COUNSELING = 'mental-health-counseling';
export const PHARMACY = 'pharmacy';
export const RESOLVER = 'resolver';
export const PHARMACY_LIST = 'pharmacies-list';
export const PHARMACY_BRAND_DETAILS = 'pharmacy-brand-details';
export const TRANSFER = 'transfer-medicine';
export const DENTAL = 'dental';
export const DENTAL_PROCEDURE = 'dental-procedures';
export const VISION_SERVICE = 'vision-service';
export const IMAGING = 'imaging';
export const LAB_TEST = 'lab-test';
export const SURGICAL = 'surgical';
export const HEALTHSHARE_SERVICE = 'healthshare-service';
export const WOW_VIDEO = 'wow-video';
export const BLOGS = 'blogs';
export const FAQS = 'faqs';
export const ABOUT_US = 'about-us';
export const CONTACT_US = 'contact-us';
export const USER_MANGEMENT = 'user-management';
export const USER_PROFILE = 'user-profile';
export const PROFILE = 'profile'
export const PROFILE_COMPLETION = 'profile-completion'
export const ADVOCATES = 'advocates'
export const DASHBOARD = 'dashboard';
export const APPOINTMENTS = 'appointments';
export const MEMBERSHIP = 'membership';
export const CANCEL = 'cancel-membership';
export const SUCCESS = 'success';
export const MAIN = 'main';
export const EMPLOYERS = 'employer-benefits';
export const FAMILY_INFO = 'family-info';
export const ACCOUNT = 'account';
export const WALLET = 'wallet';
// User Account & Auth Routes
export const AUTH_PATH = 'auth';
export const LOGIN_BASE_LINK_PATH = 'login';
export const OTP_BASE_LINK_PATH = 'otp';
export const ACCOUNT_PATH = `${PORTAL_PATH}/account`;
export const REGISTER_BASE_LINK_PATH = 'register';
export const USER_BALANCE_PATH = `${ACCOUNT_PATH}/balance`;
export const USER_SPENDINGS_PATH = `${ACCOUNT_PATH}/spendings`;
export const USER_EARNINGS_PATH = `${ACCOUNT_PATH}/earnings`;
export const USER_PROFILE_PATH = `${ACCOUNT_PATH}/profile`;
export const RESET_PASSWORD_BASE_LINK_PATH = 'reset-password';
export const FORGOT_PASSWORD_BASE_LINK_PATH = 'forgot-password';
export const LOGIN_PATH = `${AUTH_PATH}/${LOGIN_BASE_LINK_PATH}`;
export const REGISTER_PATH = `${AUTH_PATH}/${REGISTER_BASE_LINK_PATH}`;
export const RESET_PASSWORD_PATH = `${AUTH_PATH}/${RESET_PASSWORD_BASE_LINK_PATH}`;
export const FORGOT_PASSWORD_PATH = `${AUTH_PATH}/${FORGOT_PASSWORD_BASE_LINK_PATH}`;


export const ANNOTATION_PATH = `${DATASETS_PATH}/{id}/annotation`;

// PUBLIC ROUTES
export const FAQ_PATH: string = 'faq';
export const BLOG_PATH: string = 'blog';
export const ABOUT_PATH: string = 'about';
export const PRICING_PATH: string = 'pricing';
export const CONTACT_PATH: string = 'contact';
export const PRODUCT_PATH: string = 'product';
export const PRIVACY_POLICY_PATH: string = 'privacy-policy';
export const TERMS_CONDITIONS_PATH: string = 'terms-conditions';
export const DATASET_DETAIL_PATH: string = `${LANDING_PATH}dataset-detail`;

export const PROJECT_DATASET_INFERENCE_PATH: string = `${PROJECTS_PATH}/:id/inference`;
export const PROJECT_BATCH_INFERENCE_PATH: string = `${PROJECTS_PATH}/:id/batch-inference`;
export const PROJECT_INFERENCE_DETECT_PATH: string = `${PROJECT_DATASET_INFERENCE_PATH}/detect`;
export const ROUTES = {
  home: LANDING_PATH,
  plusMembership: LANDING_PATH + PLUS_MEMBERSHIP,
  register: LANDING_PATH + AUTH_PATH + LANDING_PATH + REGISTER_BASE_LINK_PATH,
  login: LANDING_PATH + AUTH_PATH,
  healthSharing: LANDING_PATH + HEALTH_SHARING,
  officeVisit: LANDING_PATH + OFFICE_VISIT,
  virtualUrgentCare: LANDING_PATH + VIRTUAL_URGENT_CARE,
  mentalHealth: LANDING_PATH + MENTAL_HEALTH_COUNSELING,
  pharmacy: LANDING_PATH + PHARMACY,
  pharmacyList : LANDING_PATH +PHARMACY_LIST,
  pharmacyBrandDetails : LANDING_PATH+PHARMACY_BRAND_DETAILS,
  transfer : LANDING_PATH +TRANSFER,
  dental: LANDING_PATH + DENTAL,
  visionService: LANDING_PATH + VISION_SERVICE,
  imaging: LANDING_PATH + IMAGING,
  labTest: LANDING_PATH + LAB_TEST,
  surgical: LANDING_PATH + SURGICAL,
  healthShare: LANDING_PATH + HEALTHSHARE_SERVICE,
  wowVideo: LANDING_PATH + WOW_VIDEO,
  blogs: LANDING_PATH + BLOGS,
  faqs: LANDING_PATH + FAQS,
  aboutUs: LANDING_PATH + ABOUT_US,
  contactUs: LANDING_PATH + CONTACT_US,
  profile: LANDING_PATH + PROFILE,
  familyInfo: LANDING_PATH + PROFILE + "/" + FAMILY_INFO,
  createFamilyInfo: LANDING_PATH + "/" + FAMILY_INFO,
  editFamilyInfo: LANDING_PATH + "/" + FAMILY_INFO,
  dashboard: LANDING_PATH + PROFILE + "/" + DASHBOARD,
  appointments: LANDING_PATH + PROFILE + "/" + APPOINTMENTS,
  membership : LANDING_PATH + PROFILE + "/" + MEMBERSHIP,
  cancel : LANDING_PATH + CANCEL,
  success : LANDING_PATH + SUCCESS,
  advocates: LANDING_PATH + "/" + ADVOCATES,
  employers: LANDING_PATH + "/" + EMPLOYERS,
  account : LANDING_PATH + PROFILE + "/" + ACCOUNT,
  wallet: LANDING_PATH + PROFILE + "/" + WALLET,
  resolver : LANDING_PATH + RESOLVER 
};
